import React, { useEffect, useState } from "react";
import {
    Col,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
} from "reactstrap";
import classnames from "classnames";
import AnnualKysRequestsApprovalTab from "./AnnualKysRequestsApprovalTab.js";
import AnnualKysRequestsPendingListTab from "./AnnualKysRequestsPendingListTab.js";
import axiosHelper from "../../../../axiosHelper.js";
import { API } from "../../../../config/constants.js";
import { notify } from "../../../../helper/util.js";

const MasterUpdateRequestsApproval = () => {
    const [activeTab, setActiveTab] = useState("1");
    // const [reviewRequestResponseData, setReviewRequestResponseData] = useState(null);

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    // useEffect(() => {
    //     const urlParams = new URLSearchParams(window.location.search);
    //     const requestId = urlParams.get("requestId");
    //     if (requestId) {
    //         GetAnnualKYSAndMasterUpdateApprovalApprovedRejectList(requestId)
    //     }
    // }, [])

    // const GetAnnualKYSAndMasterUpdateApprovalApprovedRejectList = (id) => {
    //     axiosHelper.get(`${API.GetAnnualKYSAndMasterUpdateApprovalApprovedRejectList}?requestId=${requestId}`)
    //         .then((response) => {
    //             if (response?.data?.IsSuccessful) {
    //                 setReviewRequestResponseData(response?.data?.Data);
    //             }

    //         }).catch((error) => {
    //             if (!error?.response?.data?.IsSuccessful) {
    //                 notify.error(error?.response?.data?.ErrorMessage);
    //             }
    //             // apiErrors(error);
    //             // throw error; // Re-throw the error to the caller
    //         });
    // }

    return (
        <div className="hl-vendor-need-approval-wrap hl-vl-common-wrap mt-3">
            <div className="hl-approval-tabs">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === "1" })}
                            onClick={() => {
                                toggle("1");
                            }}
                        >
                            Approval
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === "2" })}
                            onClick={() => {
                                toggle("2");
                            }}
                        >
                            Pending List
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <Row className="ag-grid-react custom-pagination without-filter-grid">
                            <AnnualKysRequestsApprovalTab />
                        </Row>
                    </TabPane>
                    <TabPane tabId="2">
                        <Row>
                            <AnnualKysRequestsPendingListTab />
                        </Row>
                    </TabPane>
                </TabContent>
            </div>

        </div>
    );
};

export default MasterUpdateRequestsApproval;
